var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm._class},[_vm._t("default"),_c('span',{class:_vm._badgeClass,style:(_vm._numberStyle)},[_vm._v(_vm._s(_vm._badgeText))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }